export enum StreamElementType {
    Add = 0, // Add elements to array
    Remove = 1, // Remove elements form array
    Update = 2, // Update/replace elements
    Done = 3, // sent when initial array initialisation complete
    Clear = 4, // Clear array of all values
    BeginBatch = 5, // Begin batch array update
    EndBatch = 6, // End batch array update
    AddOrUpdate = 99, // "upsert" functionality
    Msg = 100, // Exception messages
    OrderStat = 101, // Exception messages
    DisableRange = 102, //	Session intervals
}
